import React  from "react";
import { useParams } from 'react-router-dom';

const EditReport = () => {
	const { reportId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      </div>
	    </div>
    );
};

export default EditReport;